module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zn":{"revenueDate":"查询日期（UTC）","allSearch":"全部","invite_account":"被邀请者账号","register_time":"注册日期（UTC）","invite_bxc":"奖励收益"},"en":{"revenueDate":"Date（UTC）","allSearch":"All","invite_account":"Invited Account","register_time":"Registration Date(UTC)","invite_bxc":"Bonus"}}')
  delete Component.options._Ctor
}
